import Link from "next/link";
import React from "react";

import { Typography } from "../ui/Typography";

export const Footer: React.FC = () => {
	return (
		<footer className="bg-blu-medio h-20 w-full flex items-center justify-center px-2">
			<div className="w-[1240px] flex items-center justify-between text-bianco">
				<div className="w-80">
					<Typography variant="txt-18" color="bianco">
						Partita Iva 000000000 | REA 00000
					</Typography>
				</div>
				<div className="text-right">
					<Typography variant="txt-18" color="bianco">
						<Link href="/privacy-policy" className="hover:text-grigio transition-colors">
							Privacy Policy
						</Link>
						{" | "}
						<Link href="/cookie-policy" className="hover:text-grigio transition-colors">
							Cookie Policy
						</Link>
						{" | "}
						<Link href="/termini-condizioni" className="hover:text-grigio transition-colors">
							Termini e Condizioni
						</Link>
					</Typography>
				</div>
			</div>
		</footer>
	);
};
